package firebase

import kotlin.js.json

fun initFirebaseIfNeeded() {
    if (getApps().isEmpty()) {
        val config = json(
            "apiKey" to "AIzaSyDGS7RVxvGEF3103AEATpbwL191LZsOzsI",
            "authDomain" to "the-wedding-of-eva-danu.firebaseapp.com",
            "databaseURL" to "https://the-wedding-of-eva-danu-default-rtdb.asia-southeast1.firebasedatabase.app",
            "projectId" to "the-wedding-of-eva-danu",
            "storageBucket" to "the-wedding-of-eva-danu.firebasestorage.app",
            "messagingSenderId" to "947722087795",
            "appId" to "1:947722087795:web:00957a71ba7701df19e906",
            "measurementId" to "G-DR81W9GNMD"
        )
        initializeApp(config)
        println("✅ Firebase initialized for JS")
    }
}